import type { CollectionDto, CollectionModel } from '../../data-layer/collections/types';

export const toCollectionsModel = (collectionDto: CollectionDto): CollectionModel => ({
    id: collectionDto.id,
    url: `/collections/${collectionDto.id}`,
    displayName: collectionDto.display_name,
    numberOfPosts: collectionDto.number_of_posts,
    createdAt: collectionDto.created_at,
    previewItems: collectionDto.preview_items.map((content) => {
        if (content.type === 'image') {
            return {
                id: content.id,
                type: 'image',
                media: content.media,
            };
        }

        return {
            id: content.id,
            type: 'video',
            media: content.media.map((file) => ({
                url: file.url,
                width: file.width,
                height: file.height,
                firstFrameUrl: file.first_frame_url,
            })),
        };
    }),
    modifiable: collectionDto.modifiable,
    defaultCollection: collectionDto.default_collection,
    isPublic: collectionDto.is_public,
    isSaved: collectionDto.is_saved,
    sharingUrl: collectionDto.sharing_url,
    author: collectionDto.author
        ? {
              id: collectionDto.author.id,
              displayName: collectionDto.author.display_name,
              authorType: collectionDto.author.author_type,
              avatarUrl: collectionDto.author.avatar_url,
              shareLink: collectionDto.author.share_link,
          }
        : undefined,
    status: collectionDto.status,
    feedStatus: collectionDto.feed_status
        ? {
              showInFeed: collectionDto.feed_status.show_in_feed,
          }
        : undefined,
    isLiked: collectionDto.is_liked,
    likes: collectionDto.likes,
    footerData: collectionDto.footer_data
        ? {
              feedButtonText: collectionDto.footer_data.feed_button_text,
          }
        : undefined,
    logContext: collectionDto.log_context,
    promoteShowInFeedAvailable: collectionDto.promote_show_in_feed_available,
});
